import React from 'react';
import { IonCol, IonContent, IonGrid, IonHeader, IonPage, IonRow, IonText } from '@ionic/react';
import { useTranslation } from 'react-i18next';
import Toolbar from '../components/Toolbar';
import IntroductionTextEs from '../components/IntroductionTextEs';
import IntroductionTextEn from '../components/IntroductionTextEn';
import IntroductionTextPr from '../components/IntroductionTextPr';
import './Description.scss';
import { Language, useLanguage } from '../utils/Settings';

const Description: React.FC = () => {
	const { t } = useTranslation();
	const [language] = useLanguage();

	return (
		<IonPage id="description-page">
			<IonHeader>
				<Toolbar title={t('Introduction Title')} />
			</IonHeader>
			<IonContent fullscreen className="ion-padding">
				<IonText color="primary"><h1 className="ion-hide-xl-up"><b>{t('Introduction Title')}</b></h1></IonText>
				<IonGrid>
					<IonRow>
						<IonCol size="12">
							{language === Language.Spanish &&
								<IntroductionTextEs />
							}
							{language === Language.English &&
								<IntroductionTextEn />
							}
							{language === Language.Portuguese &&
								<IntroductionTextPr />
							}
						</IonCol>
					</IonRow>
				</IonGrid>
			</IonContent>
		</IonPage>
	);
};

export default Description;